import React from "react";
import Button from "../Button";

export default function Contact({ data }) {
  return (
    <div
      className="widget contact-info-widget bg_cover mb-[40px] wow fadeInUp"
      style={{
        backgroundImage: data?.bg?.asset
          ? `url(${data.bg?.asset?.url})`
          : "url(/assets/images/widget/contact-1.jpg)",
      }}
    >
      <div className="contact-info-box text-center">
        <div className="icon">
          <i className="far fa-phone" />
        </div>
        <div className="info">
          <h4>
            <a href={`tel:${data?.phone}`}>{data?.phone}</a>
          </h4>
          <h5>
            <a href={`mailto:${data?.email}`}>{data?.email}</a>
          </h5>
          {/* <a href="#" className="main-btn bordered-btn bordered-black">
            Contact us
          </a> */}
          {data?.button?.title && (
            <Button
              text={data.button.title}
              btnType={data?.button.btnType}
              link={data?.button.link}
              linkType={data?.button.linkType}
              border="bordered-black"
            />
          )}
        </div>
      </div>
    </div>
  );
}
